package com.cs.ejobin

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.cs.ejobin.app.AppRoot
import com.cs.ejobin.web.startScreenFromUrl

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    ComposeViewport(content = {
            AppRoot(startScreen = startScreenFromUrl())
        })
}